module.exports = __webpack_public_path__ + "img/order.2ff2999c.png";